import { Profile } from '../pages/UserDashboard/Profile';
import { AppliedJobs } from '../pages/UserDashboard/AppliedJobs';
import { JobSavedJobs } from '../pages/UserDashboard/JobSavedJobs';
import { MyResume } from '../pages/UserDashboard/Resume/index';
import { ChangePassword } from '../pages/UserDashboard/Settings/ChangePassword';

/**
 * Rutas protegidas para usuarios tipo USUARIO
 * Requieren autenticación y tipoPerfil === 'USUARIO'
 */
export const userRoutes = [
    {
        path: '/profile',
        exact: true,
        component: Profile,
        name: 'Mi Perfil',
        description: 'Perfil del candidato',
        forRole: 'USUARIO'
    },
    {
        path: '/saved-jobs',
        exact: true,
        component: JobSavedJobs,
        name: 'Vacantes Guardadas',
        description: 'Lista de vacantes guardadas',
        forRole: 'USUARIO'
    },
    {
        path: '/applied-jobs',
        exact: true,
        component: AppliedJobs,
        name: 'Vacantes Aplicadas',
        description: 'Lista de vacantes a las que se ha aplicado',
        forRole: 'USUARIO'
    },
    {
        path: '/my-resume',
        exact: true,
        component: MyResume,
        name: 'Mi Currículum',
        description: 'Currículum del candidato',
        forRole: 'USUARIO'
    },
    {
        path: '/change-password',
        exact: true,
        component: ChangePassword,
        name: 'Cambiar Contraseña',
        description: 'Cambiar contraseña del usuario',
        forRole: 'USUARIO'
    }
];
